import axios from "./axios";
import AppConfig from "../../config";



export default class registerService {
  register = async (body) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.BUSINESS_PARTNER_MANAGER_PORT}/v5/business-partner/manager/company/${AppConfig.COM_CODE}/registration`;
    //console.log("signup url", url);
    const config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const results = await axios.post(url, body, config);
    const response = await results.data;
    //console.log("signup response: ", JSON.stringify(response));
    return response;
  };

  registerUploadFile = async (regisId, body) => {

    const url = `${AppConfig.BASE_URL}:${AppConfig.BUSINESS_PARTNER_MANAGER_PORT}/v5/business-partner/manager/company/${AppConfig.COM_CODE}/registration/${regisId}/upload`;
    //console.log("registerUploadFile url", url, regisId, body);
    const config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const results = await axios.post(url, body, config);
    const response = await results.data;
    //console.log("registerUploadFile response: ", JSON.stringify(response));
    //console.log("registerUploadFile response: ", response);
    return response;
  };

  verify = async (body, id) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.BUSINESS_PARTNER_MANAGER_PORT}/v5/business-partner/manager/company/${AppConfig.COM_CODE}/registration/${id}/verification`;
    //console.log("verify url", url);
    const config = {
      method: "put",
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const results = await axios.put(url, body, config);
    const response = await results.data;
    //console.log("verify response: ", JSON.stringify(response));
    return response;
  };

  getCustomType = async () => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.BUSINESS_PARTNER_MANAGER_PORT}/v3/business-partner/manager/company/${AppConfig.COM_CODE}/customer-types/loopmerchant`;
    //console.log("verify url", url);
    const config = {
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer",
      },
    };
    const results = await axios.get(url,config);
    const response = await results.data;
    //console.log("verify response: ", JSON.stringify(response));
    return response;
  };
}

export { registerService }